/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUsageBasedInvoices200ResponseFailuresInner } from './CreateUsageBasedInvoices200ResponseFailuresInner';
import {
    CreateUsageBasedInvoices200ResponseFailuresInnerFromJSON,
    CreateUsageBasedInvoices200ResponseFailuresInnerFromJSONTyped,
    CreateUsageBasedInvoices200ResponseFailuresInnerToJSON,
    CreateUsageBasedInvoices200ResponseFailuresInnerToJSONTyped,
} from './CreateUsageBasedInvoices200ResponseFailuresInner';
import type { CreateUsageBasedInvoices200ResponseInvoicesInner } from './CreateUsageBasedInvoices200ResponseInvoicesInner';
import {
    CreateUsageBasedInvoices200ResponseInvoicesInnerFromJSON,
    CreateUsageBasedInvoices200ResponseInvoicesInnerFromJSONTyped,
    CreateUsageBasedInvoices200ResponseInvoicesInnerToJSON,
    CreateUsageBasedInvoices200ResponseInvoicesInnerToJSONTyped,
} from './CreateUsageBasedInvoices200ResponseInvoicesInner';

/**
 * 
 * @export
 * @interface CreateUsageBasedInvoices200Response
 */
export interface CreateUsageBasedInvoices200Response {
    /**
     * 
     */
    success?: boolean;
    /**
     * 
     */
    invoicesCreated?: number;
    /**
     * 
     */
    billingPeriod?: string;
    /**
     * 
     */
    invoices?: Array<CreateUsageBasedInvoices200ResponseInvoicesInner>;
    /**
     * 
     */
    failures?: Array<CreateUsageBasedInvoices200ResponseFailuresInner>;
}

/**
 * Check if a given object implements the CreateUsageBasedInvoices200Response interface.
 */
export function instanceOfCreateUsageBasedInvoices200Response(value: object): value is CreateUsageBasedInvoices200Response {
    return true;
}

export function CreateUsageBasedInvoices200ResponseFromJSON(json: any): CreateUsageBasedInvoices200Response {
    return CreateUsageBasedInvoices200ResponseFromJSONTyped(json, false);
}

export function CreateUsageBasedInvoices200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUsageBasedInvoices200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'invoicesCreated': json['invoicesCreated'] == null ? undefined : json['invoicesCreated'],
        'billingPeriod': json['billingPeriod'] == null ? undefined : json['billingPeriod'],
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(CreateUsageBasedInvoices200ResponseInvoicesInnerFromJSON)),
        'failures': json['failures'] == null ? undefined : ((json['failures'] as Array<any>).map(CreateUsageBasedInvoices200ResponseFailuresInnerFromJSON)),
    };
}

export function CreateUsageBasedInvoices200ResponseToJSON(json: any): CreateUsageBasedInvoices200Response {
    return CreateUsageBasedInvoices200ResponseToJSONTyped(json, false);
}

export function CreateUsageBasedInvoices200ResponseToJSONTyped(value?: CreateUsageBasedInvoices200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'invoicesCreated': value['invoicesCreated'],
        'billingPeriod': value['billingPeriod'],
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(CreateUsageBasedInvoices200ResponseInvoicesInnerToJSON)),
        'failures': value['failures'] == null ? undefined : ((value['failures'] as Array<any>).map(CreateUsageBasedInvoices200ResponseFailuresInnerToJSON)),
    };
}

